import React from 'react';

const PuntiRitiro = () => {
  return (
    <svg
      version="1.1"
      id="punti_ritiro_icon"
      xmlns="http://www.w3.org/2000/svg"
      xlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 80 80"
      style="enable-background:new 0 0 80 80;"
      space="preserve"
      style={{
        fill: 'none',
        stroke: 'currentColor',
        strokeWidth: 3,
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeMiterlimit: 10,
        verticalAlign: 'middle',
      }}
    >
      <g>
        <polygon points="40.38,3 3.02,20.87 3.02,58.23 40.38,76.1 77.74,58.23 77.74,20.87" />
        <line x1="16.02" y1="27.37" x2="53.38" y2="9.5" />
        <line x1="50.13" y1="61.48" x2="71.25" y2="51.73" />
        <line x1="40.38" y1="38.74" x2="40.38" y2="76.1" />
        <line x1="68" y1="35.49" x2="68" y2="46.86" />
        <polyline points="63.96,42.11 68,35.49 72.04,38.23" />
        <line x1="55" y1="41.98" x2="55" y2="53.36" />
        <polyline points="50.96,48.61 55,41.98 59.05,44.72" />
        <polyline points="16.02,27.37 16.02,37.11 25.77,41.98 25.77,32.24 63.13,14.37" />
        <polyline points="26.27,31.99 40.38,38.74 77.74,20.87" />
        <line x1="3.02" y1="20.87" x2="16.31" y2="27.22" />
      </g>
    </svg>
  );
};

export default PuntiRitiro;
